import { SVGProps } from 'react';

const Transgender = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 16v6m0-6a4 4 0 1 0 0-8 4 4 0 0 0 0 8m2 4h-4M22 6V2h-4m4 0-7.17 7.17M2 2l7.17 7.17M5.357 2H2v3.355M8 5 5 8"
    />
  </svg>
);
export default Transgender;
